/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelEdiCrossRefHandlingRequirement.ts  *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/datafusion/edi-cross-ref-handling-requirement";

export class AutogenModelEdiCrossRefHandlingRequirement<RowType extends ModelRow> extends Endpoint<RowType, RowEdiCrossRefHandlingRequirementFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowEdiCrossRefHandlingRequirement extends ModelRow<RowEdiCrossRefHandlingRequirementFields> {
	constructor(values?: Partial<RowEdiCrossRefHandlingRequirementFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowEdiCrossRefHandlingRequirementFields {
	company_id: string;
	edi_code: string;
	equipment_type_id: string;
	fgi_packaging_type_code: string;
	"handling_requirement.add_timestamp": Date;
	"handling_requirement.add_userid": string;
	"handling_requirement.company_id": string;
	"handling_requirement.date_title": string;
	"handling_requirement.float_title": string;
	"handling_requirement.gla_uid": number;
	"handling_requirement.hdr_description": string;
	"handling_requirement.hdr_id": string;
	"handling_requirement.hdr_move_type": string;
	"handling_requirement.hdr_order": number;
	"handling_requirement.hdr_title": string;
	"handling_requirement.hdr_uid": number;
	"handling_requirement.hdr_web_order": number;
	"handling_requirement.include_mobile": string;
	"handling_requirement.include_on_dr": string;
	"handling_requirement.include_on_manifest": string;
	"handling_requirement.integer_title": string;
	"handling_requirement.mod_timestamp": Date;
	"handling_requirement.mod_userid": string;
	"handling_requirement.need_date": string;
	"handling_requirement.need_float": string;
	"handling_requirement.need_integer": string;
	"handling_requirement.need_text": string;
	"handling_requirement.need_time": string;
	"handling_requirement.need_timestamp": string;
	"handling_requirement.text_title": string;
	"handling_requirement.time_title": string;
	"handling_requirement.timestamp_title": string;
	hdr_uid: number;
	id: string;
	la_business_unit: string;
	order_type_id: string;
	partner_id: string;
	revenue_code_id: string;
	seg_alloc_code: string;
	version: string;
}

